export class EmojiVo {
    public code: string = '';
    public unicode: string = '';
    public image: string = '';
    public description: string = '';
    constructor(code: string, unicode: string, image: string, description: string) {
        this.code = code;
        this.unicode = unicode;
        this.image = image;
        this.description = description;
    }
    
}